import { TextField } from '@mui/material';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers';
import * as React from 'react';
import { Control, Controller, UseFormRegisterReturn } from 'react-hook-form';
import { MuiPropsToOmit } from './dateAndTimeUtils';
import { fieldHighlightStyle } from './utils';

const format = 'dd-MMM-yyyy HH:mm';

interface ImpactDateTimePickerProps extends Omit<DateTimePickerProps<any>, MuiPropsToOmit> {
    registerReturn: UseFormRegisterReturn;
    control: Control;
    label: string;
    disabled?: boolean;
    required?: boolean;
    highlighted?: boolean;
}
export const ImpactDateTimePicker: React.FC<ImpactDateTimePickerProps> = (props) => {
    const { registerReturn, control, required, highlighted } = props;
    const { ref, ...registered } = registerReturn;

    return (
        <Controller
            control={control}
            {...registered}
            render={({ field: { ref: _, ...field }, fieldState }) => {
                return (
                    <DateTimePicker
                        //for MUI props
                        {...props}
                        {...field}
                        //otherwise optional empty fields will display as errors because
                        //they get passed new Date(undefined) -> Invalid Date
                        value={field.value ? new Date(field.value) : props.defaultValue ?? null}
                        format={format}
                        ampm={false}
                        slots={{
                            textField: TextField,
                        }}
                        slotProps={{
                            textField: {
                                size: 'small',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message || undefined,
                                fullWidth: true,
                                required,
                                name: field.name,
                                sx: highlighted ? fieldHighlightStyle : undefined,
                            },
                            field: {
                                clearable: true,
                            },
                        }}
                    />
                );
            }}
        />
    );
};
